import { z } from "zod";
import { PromptMetaSchema, PromptTestCaseSchema } from "../../../../schemas/PromptSchema";
import { providerAPIs } from "../../../models/constants/providerAPIs";

export const defaultPromptMeta = {
  model: "gpt-4o-mini",
  messages: [
    { role: "system", content: "", attachments: [] },
    { role: "user", content: "", attachments: [] },
  ],
  tools: [],
  temperature: 1,
  max_completion_tokens: 1000,
  top_p: 1,
  presence_penalty: 0,
  frequency_penalty: 0,
  response_format: "text",
  stream: true,
  provider_api: providerAPIs.CHAT_COMPLETIONS,
  display_mode: "basic" as const,
};

export const NewPromptSchema = z.object({
  id: z.string().optional(),
  icon: z.string().default("openai"),
  name: z.string().trim().default(""),
  parent_id: z.string().nullable().default(null),
  meta: PromptMetaSchema.default(defaultPromptMeta),
  test_cases: z.array(PromptTestCaseSchema).default([]),
});

export type NewPrompt = z.infer<typeof NewPromptSchema>;
